import React from 'react';
import PropTypes from 'prop-types';

const ErrorComponent = props => {
  return props.error ? (
    <div className="form-error">{Array.isArray(props.error) ? props.error[0] : props.error}</div>
  ) : null;
};

ErrorComponent.propTypes = {
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
};

export default ErrorComponent;